import React from 'react'
import AppBlobCache from '../../AppBlobCache'

function dataURItoBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(dataURI.split(',')[1]);
  else
    byteString = unescape(dataURI.split(',')[1]);
  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], {type:mimeString});
}

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {

    }
  }

  render()
  {
    return (
        <div class="">
          <input
              type={`file`}
              className={`form-control form-control-sm`}
              onChange={(e) => {
                
                if (e.target.files && e.target.files.length > 0 && e.target.files[0])
                {

                  if (this.props.file_type=='image' && e.target.files[0].size>1024*1024)
                  {
                    alert("圖片上限為1MB"); e.target.value = null;return false;
                  }

                  if (this.props.file_type=='video' && e.target.files[0].size>4*1024*1024)
                  {
                    alert("影片上限為4MB"); e.target.value = null;return false;
                  }
                  var reader = new FileReader();
                  reader.onload = ((theFile) => {
                    return (e) => {
                      // console.log('1', e.target.result);
                      console.log('2', theFile.name);
                      // console.log(blob_url);

                      var blob_url = window.URL.createObjectURL(dataURItoBlob(e.target.result));
                      var base64_raw = e.target.result;

                      var file_keys = theFile.name.split('.');
                      if (file_keys.length > 1) {
                        file_keys.length = file_keys.length - 1;
                      }
                      var file_key = file_keys.join('.');
                      file_key = file_key.replace(/[^a-z0-9]/gi, '_');
                      file_key = file_key+"-"+new Date().valueOf();
                      console.log('file_key:'+file_key);


                      new AppBlobCache().putMediaBlobByKey(
                          `/media/${this.props.file_type}/${file_key}.${this.props.file_ext}`,
                          {
                            ext: this.props.file_ext,
                            filename: file_key,
                            type: this.props.file_type,
                            blob_url: blob_url,
                          });

                      console.log(new AppBlobCache().getMediaBlobs());

                      this.props.onChange && this.props.onChange(e, file_key, blob_url, base64_raw, this.props.file_ext);

                      // var span = document.createElement('span');
                      // span.innerHTML = ['<img class="thumb" src="', e.target.result,
                      //   '" title="', escape(theFile.name), '"/>'].join('');
                      // document.getElementById('list').insertBefore(span, null);
                    };
                  })(e.target.files[0]);
                  reader.readAsDataURL(e.target.files[0]);
                }
                else
                {
                  this.props.onChange && this.props.onChange(e, null, null, null);
                }
              }}
          />
          {this.props.value}<br/>
          {(this.props.file_type=='image')?'圖片上限為1MB':null}
          {(this.props.file_type=='video')?'影片上限為4MB':null}<br/>
          注意：若故事檔案超過8MB或影響閱讀流暢度
        </div>
    )
  }
}